import React from 'react';
import './Services.css';

function Services() {
  return (
    <section id="services" className="services">
      <h2>What I Do</h2>
      <div className="skill-icons">
          <div className="skill-item">
            <img src="/canva.png" alt="Canva" className="skill-icon" loading="lazy" />
            <div className="skill-label">Canva</div>
          </div>
          <div className="skill-item">
            <img src="/wordpress.png" alt="Wordpress" className="skill-icon" loading="lazy" />
            <div className="skill-label">Wordpress</div>
          </div>
          <div className="skill-item">
            <img src="/c.png" alt="C" className="skill-icon" loading="lazy" />
            <div className="skill-label">C</div>
          </div>
          <div className="skill-item">
            <img src="/cpp.png" alt="C++" className="skill-icon" loading="lazy" />
            <div className="skill-label">C++</div>
          </div>
          <div className="skill-item">
            <img src="/html.png" alt="HTML" className="skill-icon" loading="lazy" />
            <div className="skill-label">HTML</div>
          </div>
          <div className="skill-item">
            <img src="/css.png" alt="CSS" className="skill-icon" loading="lazy" />
            <div className="skill-label">CSS</div>
          </div>
          <div className="skill-item">
            <img src="/javascript.png" alt="JavaScript" className="skill-icon" loading="lazy" />
            <div className="skill-label">JavaScript</div>
          </div>
          <div className="skill-item">
            <img src="/github.png" alt="GitHub" className="skill-icon" loading="lazy" />
            <div className="skill-label">GitHub</div>
          </div>
          <div className="skill-item">
            <img src="/photoshop.png" alt="Photoshop" className="skill-icon" loading="lazy" />
            <div className="skill-label">Photoshop</div>
          </div>
          <div className="skill-item">
            <img src="/figma.png" alt="Figma" className="skill-icon" loading="lazy" />
            <div className="skill-label">Figma</div>
          </div>
          <div className="skill-item">
            <img src="/react.png" alt="React" className="skill-icon" loading="lazy" />
            <div className="skill-label">React</div>
          </div>
          <div className="skill-item">
            <img src="/nextjs.png" alt="Next.js" className="skill-icon" loading="lazy" />
            <div className="skill-label">Next.js</div>
          </div>
          <div className="skill-item">
            <img src="/mysql.png" alt="MySQL" className="skill-icon" loading="lazy" />
            <div className="skill-label">MySQL</div>
          </div>
      </div>
    </section>
  );
}

export default Services;
